import { FabricDetector } from './FabricDetector';

/**
 * Demo / test double: deterministic-ish "fabric" size so UI can be exercised without a real scene.
 * Wire `new MockFabricDetector({ coverageRatio: 0.62 })` to force outcomes in QA.
 *
 * @extends FabricDetector
 */
export class MockFabricDetector extends FabricDetector {
  /**
   * @param {{ coverageRatio?: number, confidence?: number, centroidX?: number }} [opts]
   */
  constructor(opts = {}) {
    super();
    this._coverage = opts.coverageRatio ?? 0.62;
    this._confidence = opts.confidence ?? 0.95;
    this._centroidX = opts.centroidX ?? 0.5;
  }

  /**
   * @param {ImageData} imageData
   * @returns {Promise<import('../types').FabricRegionMetrics>}
   */
  async detectFromImageData(imageData) {
    const w = imageData.width;
    const h = imageData.height;
    const area = w * h * this._coverage;
    const aspect = w / h;
    let bw = Math.sqrt(area * aspect);
    let bh = area / bw;
    bw = Math.min(bw, w * 0.95);
    bh = Math.min(bh, h * 0.95);
    const x0 = (w - bw) / 2 + (this._centroidX - 0.5) * w * 0.15;
    const y0 = (h - bh) / 2;
    return {
      coverageRatio: this._coverage,
      bboxX: x0 / w,
      bboxY: y0 / h,
      bboxW: bw / w,
      bboxH: bh / h,
      centroidX: this._centroidX,
      centroidY: 0.5,
      confidence: this._confidence,
    };
  }
}
